import { render, staticRenderFns } from "./Holdpoint.vue?vue&type=template&id=39daa350"
import script from "./Holdpoint.vue?vue&type=script&lang=js"
export * from "./Holdpoint.vue?vue&type=script&lang=js"
import style0 from "./Holdpoint.vue?vue&type=style&index=0&id=39daa350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports